import { connect, MapStateToProps } from 'react-redux';
import {
  getCurrentUser,
  getIsMobile,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { AppState } from '../../../../types/store';
import {
  selectors,
  CommentableTypes,
} from '@wix/da-shared-react/pkg/CommentThread';
import { Props } from './ProfileCommentsBox';

type StateProps = Pick<
  Props,
  'currentUser' | 'profileOwnerUser' | 'isOwner' | 'isMobile' | 'totalCount'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const currentUser = getCurrentUser(state);
  const profileOwnerUser = getProfileOwnerUser(state);
  return {
    profileOwnerUser,
    currentUser: currentUser as any, // TODO: update when CommentThread supports currentUser: null
    isOwner: isCurrentUserProfileOwner(state),
    isMobile: getIsMobile(state),
    totalCount: selectors.getTotal(
      state,
      CommentableTypes.COMMENT_USER,
      profileOwnerUser.userId
    ),
  };
};

export default connect(mapStateToProps);
